import { PageHeader } from '@flos/react-ui';
import { useHippoText } from '../../hooks/useHippoText';
import { useRecoilValue } from 'recoil';
import { topConfigContextAtom } from '../../recoil/atoms/topConfigContextAtom';
import { fetchedPaymentInformationAtom } from '../../recoil/atoms/fetchedPaymentInformationAtom';
import { PAYMENT_PLAN } from '../../constants/paymentMethods';

const ReceiptPendingHeader = ({
    isQuoteAlreadyIssued = false,
    policyHolderEmail = '',
    coverableAmount = 0
}: {
    isQuoteAlreadyIssued: boolean;
    policyHolderEmail: string;
    coverableAmount: number;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const topConfigContext = useRecoilValue(topConfigContextAtom);
    const paymentMethod = useRecoilValue(fetchedPaymentInformationAtom).paymentMethod ?? '';
    const content = [
        coverableAmount === 1
            ? getHippoText('DSS-ALTERNATIVE-RECEIPT-PAGE-PENDING-TAKE-CARE-INSURANCE')
            : getHippoText('DSS-ALTERNATIVE-RECEIPT-PAGE-PENDING-TAKE-CARE-INSURANCES'),
        coverableAmount === 1
            ? getHippoText('DSS-ALTERNATIVE-RECEIPT-PAGE-PENDING-RECEIVE-NEW-POLICY')
            : getHippoText('DSS-ALTERNATIVE-RECEIPT-PAGE-PENDING-RECEIVE-NEW-POLICIES'),
        paymentMethod === PAYMENT_PLAN.FIK
            ? coverableAmount === 1
                ? getHippoText('DSS-ALTERNATIVE-RECEIPT-PAGE-PENDING-INSURANCE-HEAR-FROM-US')
                : getHippoText('DSS-ALTERNATIVE-RECEIPT-PAGE-PENDING-INSURANCES-HEAR-FROM-US')
            : coverableAmount === 1
              ? getHippoText('DSS-ALTERNATIVE-RECEIPT-PAGE-PENDING-DEDUCT-PAYMENT')
              : getHippoText('DSS-ALTERNATIVE-RECEIPT-PAGE-PENDING-DEDUCT-PAYMENTS'),
        `${getHippoText(
            'DSS-ALTERNATIVE-RECEIPT-PAGE-PENDING-RECEIPT-TO-EMAIL'
        )} ${policyHolderEmail}`
    ];
    return (
        <>
            <PageHeader
                title={
                    isQuoteAlreadyIssued
                        ? getHippoText('DSS-RECEIPT-PAGE-ACCEPTED-HEADER')
                        : getHippoText('DSS-ALTERNATIVE-RECEIPT-PAGE-PENDING-HEADER')
                }
                imageUrl={`${topConfigContext?.resourceUrl ?? ''}/images/insurance-2.svg`}
                subtitle={getHippoText('DSS-ALTERNATIVE-RECEIPT-PAGE-PENDING-SUBHEADER')}
                style={{ marginLeft: -16, marginRight: -16 }} // Only way to counteract the padding. Ulrich approved.
            >
                <div>
                    <ul className="u-spacing-stack-l">
                        {content.map((text, id) => (
                            <li key={id}>{text}</li>
                        ))}
                    </ul>
                </div>
            </PageHeader>
        </>
    );
};

export default ReceiptPendingHeader;
